import httpHandler from "../../../utils/httpHandler";
import * as actionTypes from "../constants/actionTypes";


export function listFlags(args) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            httpHandler
                .post("/api/flag/list", args)
                .then((response) => {
                    resolve(response);
                    dispatch({type: actionTypes.FLAGS_LIST, payload: response.data});
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };
}

export function remove(id, callback) {
    return (dispatch) => {
        httpHandler
            .post("/api/flag/delete", {id: id})
            .then((response) => {
                dispatch({type: actionTypes.FLAGS_REMOVE, payload: id});
                callback();
            })
            .catch((error) => {
                callback();
            });
    };
}

export function clearFlags() {
    return (dispatch) => {
        dispatch({type: actionTypes.FLAGS_LIST_CLEAR});
    };
}
